import { InputSelect as InputSelectComponent } from '../../../Select'
import { Container } from '../../Container'
import { SELECTS_OPTIONS } from '../Selects.constants'
import { useSelectState } from '../Selects.hooks'

function InputSelect() {
  const { handleClear, handleSelectItem, value } = useSelectState()

  return (
    <Container label='Sync input select with search input inside control'>
      <InputSelectComponent
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: 'Select',
            },
          },
        }}
        options={SELECTS_OPTIONS}
        style={{ width: 240 }}
        value={value}
        onClear={handleClear}
        onSelectItem={handleSelectItem}
      />
    </Container>
  )
}

export default InputSelect
